import React from 'react';
import { BriefcaseIcon, PlusCircleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { PencilSquareIcon } from '@heroicons/react/24/solid';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CustomTooltipComponent from './custom_tooltip_component';
import { formatHoursAndMinutes } from '../utils/workTimeCount';


const WeekCalendarEditShift = ({ daysOfWeek, slotsByDay, weekWorkingHourId, handleAddTimeSlot, onDeleteWeeklyWorkingHourSlot, onDeleteTimeSlot, onEditWeekTimeSlot, handleConfirmEditTimeSlot }) => {
  const formatTime = (time) => time?.slice(0, 5);
   
  const getTotalWeeklyHoursFromSlots = (slotsByDay) => {
    let totalMinutes = 0;

    const getBreaksDuration = (breaks) => {
      if (!Array.isArray(breaks)) return 0;
      return breaks.reduce((sum, b) => sum + (b.duration || 0), 0);
    };

    slotsByDay.forEach((slot) => {
      if (!slot) return;

      if (Array.isArray(slot.time_slots)) {
        totalMinutes += slot.time_slots.reduce((sum, ts) => {
          const slotDuration = ts.duration || 0;
          const breaksDuration = getBreaksDuration(ts.breaks);
          return sum + (slotDuration - breaksDuration);
        }, 0);
      }

      if (slot.working_hour && Array.isArray(slot.working_hour.time_slots)) {
        totalMinutes += slot.working_hour.time_slots.reduce((sum, ts) => {
          const slotDuration = ts.duration || 0;
          const breaksDuration = getBreaksDuration(ts.breaks);
          return sum + (slotDuration - breaksDuration);
        }, 0);
      }
    });

    return totalMinutes / 60;
  };
  
  const totalWeeklyHours = getTotalWeeklyHoursFromSlots(slotsByDay);
  
  return (
    <>
    <div className='text-gray-700 text-left text-sm font-semibold pt-2'>
      Totale ore settimanali: {formatHoursAndMinutes(totalWeeklyHours)}
    </div>
      <div className="overflow-x-auto my-8 rounded-md shadow-md">
        <table className="border border-gray-200 rounded-xl shadow-md w-full table-auto">
          <thead>
            <tr>
              {daysOfWeek.map((day, index) => (
                <th
                  key={index}
                  className="border border-gray-300 text-center bg-indigo-50 px-1 py-2 text-gray-700 text-sm font-semibold w-[110px] min-w-[110px] max-w-[110px]"
                >
                  {day}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr className='h-40'>
              {daysOfWeek.map((dayLabel, index) => {
                const slotData = slotsByDay[index + 1] || {};
                const timeSlots = slotData.working_hour?.time_slots || slotData.time_slots || [];

                
                return (
                  <td
                    key={index}
                    className="border border-gray-200 text-sm px-1 py-2 w-[110px] min-w-[110px] max-w-[110px] h-40 align-top"
                  >
                    <div className="flex flex-col justify-between h-full items-center">
                      <div className="w-full flex flex-col items-center">
                        {timeSlots.length > 0 ? (
                          <div className="flex flex-col justify-start items-center w-full">
                            {timeSlots.map((slot, i) => (
                              <div key={i} className="mb-2 w-full">
                                <div className="flex justify-center items-center space-x-1 whitespace-nowrap font-semibold text-sm">
                                  <BriefcaseIcon className="w-4 h-4 text-indigo-700" />
                                  <span className='text-gray-800'>{formatTime(slot.start_at)} - {formatTime(slot.end_at)}</span>
                                </div>
                                {slot.breaks?.length > 0 && (
                                  <div className="text-xs text-gray-600 mt-1 flex flex-col space-y-1">
                                    {slot.breaks.map((p, j) => (
                                      <div key={j} className="flex justify-center items-center">
                                        <LocalBarIcon style={{ height: '14px', width: '14px', color: '#4338ca', marginRight: '6px' }} />
                                        <span>{formatTime(p.start_at)} - {formatTime(p.end_at)}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {!slotData.working_hour?.name && (
                                  <div className="flex mt-1 py-1 gap-2">
                                    <CustomTooltipComponent title='Modifica fascia oraria' placement="bottom" arrow>
                                      <button 
                                        className="w-1/2 flex justify-center border border-indigo-100 hover:bg-indigo-50 py-0.5 hover:scale-110 cursor-pointer rounded-md"
                                        onClick={() => onEditWeekTimeSlot(slot, index, weekWorkingHourId, index + 1)}
                                      >
                                        <PencilSquareIcon className="w-4 h-4 text-indigo-800" />
                                      </button>
                                    </CustomTooltipComponent>
                                    <CustomTooltipComponent title='Elimina fascia oraria' placement="bottom" arrow>
                                      <button 
                                        className="w-1/2 flex justify-center border border-indigo-100 hover:bg-indigo-50 py-0.5 hover:scale-110 cursor-pointer rounded-md"
                                        onClick={() => {
                                          onDeleteTimeSlot(slot.id, slotData, weekWorkingHourId);
                                        }}
                                      >
                                        <TrashIcon className="w-4 h-4 text-indigo-800" />
                                      </button>
                                    </CustomTooltipComponent>
                                  </div>
                                )}
                                {i < timeSlots.length - 1 && <hr className="my-1 border-gray-300" />}
                              </div>
                            ))}
                            {slotData.working_hour?.name && (
                              <CustomTooltipComponent title={slotData.working_hour.name} placement="bottom" arrow>
                                <div className="text-xs text-indigo-800 font-semibold my-2 text-center bg-indigo-50 rounded-xl mx-1 py-0.5 px-1 cursor-pointer">
                                  <AttachFileOutlinedIcon
                                    className="inline-block text-indigo-800 text-xs flex"
                                    style={{ width: "15px", height: "15px" }}
                                  /> Turno giorn.
                                </div>
                              </CustomTooltipComponent>
                            )}
                          </div>
                        ) : (
                          <div className="text-xs text-gray-400 text-center mb-2">Nessun orario</div>
                        )}
                      </div>

                      <div className="flex justify-center mt-2 border-t border-gray-300 pt-2 w-full space-x-2">
                        {slotData.working_hour ? (
                          <CustomTooltipComponent title='Elimina turno giornaliero' placement="bottom" arrow>
                            <button
                              onClick={() => onDeleteWeeklyWorkingHourSlot(slotData.id)}
                              className="text-indigo-800 hover:text-red-700 font-bold text-lg cursor-pointer"
                            >
                              <TrashIcon className="h-5 w-5" />
                            </button>
                          </CustomTooltipComponent>
                        ) : (
                          <CustomTooltipComponent title='Aggiungi fascia oraria' placement="bottom" arrow>
                            <button
                              onClick={() => handleAddTimeSlot(index, slotData)}
                              className="text-indigo-800 hover:text-indigo-700 font-bold text-lg cursor-pointer"
                            >
                              <PlusCircleIcon className="h-5 w-5" />
                            </button>
                          </CustomTooltipComponent>
                        )}
                      </div>
                    </div>
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WeekCalendarEditShift;
